import { Layer, Source } from "react-map-gl/maplibre";

import { Raster, RasterStyle } from "@nens/lizard/api-v4";
import { getWmsRequest } from "@nens/react-map-gl/utils";

interface RasterLayerProps {
  raster: Raster;
  rasterStyle: RasterStyle;
}

export function RasterLayer({ raster, rasterStyle }: RasterLayerProps) {
  // For adding color range etc, see map-layer-lizard-raster.tsx in Lizard-viewer's components.
  const { wms_info, temporal, uuid } = raster;

  if (temporal) return null; // Later.

  const layer = wms_info.layer;

  const wmsUrl = getWmsRequest("https://ldo.lizard.net/wms/", {
    layer: layer,
    styles: rasterStyle.toString(),
    transparent: false,
    time: null,
  });

  return (
    <Source key={wmsUrl} id={"source-" + uuid} type="raster" tiles={[wmsUrl]} tileSize={256}>
      <Layer id={uuid} minzoom={0} maxzoom={22} type="raster" paint={{ "raster-opacity": 1 }} />
    </Source>
  );
}
